import React from 'react'
import { withPrefix } from 'gatsby';
import { GTMEvents } from '../../../../../lib/GTMevents';
import Btn from '../../../../buttons/buttons';
import { ExclamationCircle } from '../../../../../svg/exclamation_circle';
import s from './index.module.css'

const ComoMeCambioDeFondo = () => {
  return (
    <div className={'containerWrap'}>
      <h2 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-24@lg center tw-mb-4 tw-mb-4@lg tw-mt-0">
        ¿Cómo me cambio de fondo?
      </h2>

      <div className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg center w-80 w-60@lg ml-auto mr-auto tw-mb-12 tw-mb-12@lg">
        Si has evaluado cambiarte de tipo de fondo, Prima AFP te da{' '}<strong>tres opciones</strong> para realizar el cambio:
      </div>

      <div className={`flex@lg`}>
        <div className={`w-100 w-50@lg border border-gray-0 brad-4 shadow-1 tw-py-10 tw-px-6 tw-px-18@lg font-family-primary tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-0@lg`}>
          <div className={`center`}>
            <img
              src={withPrefix('/images/circle_classification.svg')}
              alt="circle_classification"
              className={`${s.imagenBox9} m-auto db tw-mb-6 tw-mb-2@lg`}
            />

            <h3 className={`tw-mb-4 fw-7 font-family-secondary c-orange-0 tw-f-24 c-orange-0 center tw-mt-0`}>
              APP PRIMA
            </h3>

            <div className={`tw-mb-4 font-family-primary tw-f-16 tw-f-20@lg tw-mb-12 center`}>
              Ingresa a la sección solicitudes y trámites, cambio de fondo y llena el formulario. Para ello,{' '}<strong>descarga el APP Prima AFP</strong> desde:
            </div>

            <div className="flex direction-column items-center justify-center">
              <div className="border border-gray-0 brad-4 shadow-2 flex tw-p-4 w-100 w-80@lg ml-auto mr-auto tw-mb-4">
                <img
                  src={withPrefix('/images/logo-appstore.svg')}
                  alt="logo-appstore"
                  height={40}
                  className={``}
                />

                <div className="w-80 flex items-center tw-pl-4 tw-pl-4@lg">
                  <span>
                    Disponible en{' '}
                    <a
                      href="https://itunes.apple.com/pe/app/prima-afp/id771086230?mt=8"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <strong>APP Store</strong>
                    </a>
                  </span>
                </div>
              </div>

              <div className="border border-gray-0 brad-4 shadow-2 flex tw-p-4 w-100 w-80@lg ml-auto mr-auto tw-mb-4">
                <img
                  src={withPrefix('/images/logo-playstore.svg')}
                  alt="logo-playstore"
                  height={40}
                  className={``}
                />

                <div className="w-80 flex items-center tw-pl-4 tw-pl-4@lg">
                  <span>
                    Disponible en{' '}
                    <a
                      href="https://play.google.com/store/apps/details?id=prima.android.splashscreentest"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <strong>Google Play</strong>
                    </a>
                  </span>
                </div>
              </div>

              <div className="border border-gray-0 brad-4 shadow-2 flex tw-p-4 w-100 w-80@lg ml-auto mr-auto">
                <img
                  src={withPrefix('/images/logo-huawei.svg')}
                  alt="logo-huawei"
                  height={40}
                  className={``}
                />
                <div className="w-80 flex items-center tw-pl-4 tw-pl-4@lg">
                  <span>
                    Disponible en{' '}
                    <a
                      href="https://appgallery.cloud.huawei.com/ag/n/app/C101754377?channelId=marketing&detailType"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <strong>APP Gallery</strong>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`w-100 w-50@lg tw-pl-8@lg`}>
          <div className={`flex@lg border border-gray-0 brad-4 shadow-1 tw-px-4 tw-pr-8@lg tw-py-4 tw-py-8@lg font-family-primary tw-f-16 tw-f-16@lg tw-mb-8`}>
            <div className={`w-20 w-20@lg flex justify-center tw-mb-4 tw-mb-0@lg`}>
              <img
                src={withPrefix('/images/circle_navigation.svg')}
                alt="circle_navigation"
                className={`${s.imagenBox9}`}
              />
            </div>

            <div
              id="GTM-MOD-MEP-SECTION-TP-BTN-CONTAINER-ACCOUNT"
              className={`w-90 w-80@lg`}
            >
              <h3 className={`tw-mb-4 fw-7 font-family-secondary c-orange-0 tw-f-24 tw-mt-0`}>
                Vía online
              </h3>

              <div className={`tw-mb-4 font-family-primary tw-f-16 tw-f-20@lg tw-mb-6`} >
                Ingresa a la sección{' '}<strong>“Cambio de tipo de fondo”</strong> de tu cuenta personal con tu documento de identidad y clave web.
              </div>

              <div
                onClick={() =>
                  GTMEvents.FundChangeTypeSectionBtn(
                    'tipos de fondo',
                    '¿Cómo me cambio de fondo?',
                    'Ir a cuenta',
                    'https://miespacio.prima.com.pe/bienvenido'
                  )
                }
                className="flex items-center justify-start"
              >
                <Btn
                  id="GTM-MOD-MEP-SECTION-TP-BTN-TIPE-ACCOUNT"
                  type="link"
                  href="https://miespacio.prima.com.pe/bienvenido"
                  target="_blank"
                  size="medium"
                  label="Ir a cuenta"
                  className="font-family-secondary tw-f-18 tw-px-4 tw-py-3 block center w-60 w-auto@md"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`brad-4 bg-turquoise-1 tw-p-4 font-family-primary tw-f-16 tw-f-16@lg tw-mt-8`}>
        <div className={`flex`}>
          <div className={`tw-mr-2`}>
            <ExclamationCircle fill={'#04A6A2'} />
          </div>

          <div>
            <p>
              <strong>¿Cuándo se hace efectivo el cambio de mi tipo de fondo?</strong>
              <br />
              El sexto día hábil del mes siguiente al que presentaste tu solicitud, siempre que esta haya sido aprobada.
              <br />
              <strong>¿Cómo veo el estado de mi solicitud?</strong>
              <br />
              En la sección “Estado de solicitud” de tu{' '}
              <a
                onClick={() =>
                  GTMEvents.FundTypeLinkSection(
                    'tipos de fondo',
                    '¿Cómo me cambio de fondo?',
                    'cuenta personal',
                    'https://miespacio.prima.com.pe/bienvenido'
                  )
                }
                href="https://miespacio.prima.com.pe/bienvenido"
                rel="noopener noreferrer"
                target="_blank"
                className="c-orange-0 b"
              >
                cuenta personal.
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
};

export default ComoMeCambioDeFondo;
